<template>
  <div>
    <!--v-show="show"-->
    <div align="right">
      <el-form :inline="true" class="style1">
        <el-form-item>
          <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">
            {{$t("general.add")}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.comName }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="被保険者数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.people }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="個人別票枚数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sheet }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" width="360">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- adding new -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-form-item :label="$t('general.date')+':'" prop="date">
          <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
          <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="届出被保険者数:">
          <el-input-number v-model="inputForm.people" size="mini" style="width: 80%;" controls-position="right" :min="0"></el-input-number>&emsp;人
        </el-form-item>

        <el-form-item label="個人別票枚数:">
          <el-input-number v-model="inputForm.sheet" size="mini" style="width: 80%;" controls-position="right" :min="0"></el-input-number> &emsp;枚
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="add('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!-- edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogEdit" width="30%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-form-item :label="$t('general.date')+':'" prop="date">
          <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
          <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="届出被保険者数:">
          <el-input-number v-model="inputForm.people" size="mini" style="width: 80%;" controls-position="right" :min="0"></el-input-number>&emsp;人
        </el-form-item>

        <el-form-item label="個人別票枚数:">
          <el-input-number v-model="inputForm.sheet" size="mini" style="width: 80%;" controls-position="right" :min="0"></el-input-number> &emsp;枚
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="edit('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <div style="text-align: left; margin-top: 50vh; font-size: smaller; width: fit-content; ">
      <el-row :gutter="40">
        <el-col :md=12>
          <el-card style="background-color: #51d1ff1c;">
            注意
            <ul>
              <li>
                この帳票は、「
                <el-link @click="jump('empInsMyNumberGroup')">
                  個人番号登録届出書（連記式）個人別票
                </el-link>
                」と合わせて使用すること。
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :md=12>
          <el-card style="background-color: #51d1ff1c;">
            お願い
            <ul>
              <li>
                被保険者の方から個人番号（マイナンバー）を取得する際は、
                <ol>
                  <li>
                    正しい番号であることの確認（番号確認）と
                  </li>
                  <li>
                    正しい番号の持ち主であることの確認（身元確認）
                  </li>
                </ol>を必ず行ってください。
              </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,

      labelPosition: "left",

      dialogVisible: false,
      dialogEdit: false,

      tableData: [],
      companyInfo: [],

      inputForm: {
        id: "",
        company_id: "",
        date: "",
        people: "",
        sheet: ""
      },

      rules: {
        company_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        date: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
      },
    };
  },
  methods: {
    preview(row) {
      var uid = window.localStorage.getItem('LoginUserId');
      window.open(
        "/pdf/個人番号登録届出書(連記式)総括票-" + row.comName + row.date + row.people + "人" + row.sheet + "枚.pdf"
      );
    },

    printPDF(index, row) {
      let postData = this.qs.stringify({
        id: row.id
      });
      this.axios({
        method: "post",
        url: "/empInsMyNumberSummaryPDF",
        data: postData
      })
        .then((response) => {
          if (response.data.status = "success") {
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(row);
            }, 300);
          } else {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
          }
        })
        .catch(error => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed")
          });
        });
    },


    add(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            company_id: this.inputForm.company_id,
            date: this.inputForm.date,
            people: this.inputForm.people,
            sheet: this.inputForm.sheet
          });
          this.axios({
            method: "post",
            url: "/insertEmpInsMyNumberSummary",
            data: postData
          })
            .then(response => {
              this.$message({
                type: "success",
                message: this.$t("general.add_completed")
              });
              this.currentPage = 1;
              this.getPages();
              this.dialogVisible = false;
              this.emptyForm();
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed")
              });
              console.log(error);
            });
        } else {
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleEdit(index, row) {
      this.dialogEdit = true;
      this.inputForm = Object.assign({}, row);
    },

    edit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.inputForm.id,
            company_id: this.inputForm.company_id,
            date: this.inputForm.date,
            people: this.inputForm.people,
            sheet: this.inputForm.sheet
          });
          this.axios({
            method: "post",
            url: "/updateEmpInsMyNumberSummary",
            data: postData
          })
            .then(response => {
              this.handleCurrentChange();
              this.dialogEdit = false;
              this.emptyForm();
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed")
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id
          });
          this.axios({
            method: "post",
            url: "/deleteEmpInsMyNumberSummary",
            data: postData
          })
            .then(response => {
              this.getPages();
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed")
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled")
          });
        });
    },

    jump(path) {
      this.$router.push(path);
    },

    cancel() {
      this.dialogVisible = false;
      this.dialogEdit = false;
      this.emptyForm();
    },

    emptyForm() {
      this.inputForm = {
        id: "",
        company_id: "",
        date: "",
        people: "",
        sheet: "",
      }
      this.$refs['inputForm'].resetFields();
    },

    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(_ => {
          done();
          this.emptyForm();
        })
        .catch(_ => { });
    },

    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/pageEmpInsMyNumberSummary",
        data: postData
      })
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPages() {
      this.axios
        .post("/pageEmpInsMyNumberSummary")
        .then(response => {
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });
      this.axios
        .post("/rowsEmpInsMyNumberSummary")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  created() {
    this.getPages();

    //get Company List
    this.axios
      .post("/ListComInfo")
      .then((response) => {
        this.companyInfo = response.data;
        console.log(this.companyInfo);
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.style1 {
  margin-right: 100px;
  padding: 0px;
  text-align: right;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpInsMyNumberSummary.vue